import axios from 'axios';
import { store } from '../store/store';
import { setNoAccess } from '../store/slices/userSlice';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://c2s-app-api-timesheet-prod-wus2-01.azurewebsites.net/api'
});

// Request interceptor to add idToken
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('idToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Extract the nested result data
    if (response.data?.result?.result) {
      return { data: response.data.result.result };
    }
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.clear();
          sessionStorage.removeItem("hasClicked");
          store.dispatch(setNoAccess({ noAccess: true, errorCode: 401 }));
          break;
        case 403:
          // localStorage.removeItem('userType');
          sessionStorage.removeItem("hasClicked");
          break;
          case 404:
            store.dispatch(setNoAccess({ noAccess: true, errorCode: 404 }));
            break;
        default:
          break;
      }
    }
    return Promise.reject({
      status: error.response?.status,
      message: error.response?.data?.message || error.response?.data?.detail
    });
  }
);

export const getUserData = async () => {
  try {
    const response = await api.get('/Users/me');
    return response;
  } catch (error) {
    throw {
      status: error.status,
      message:  error?.message || "Something went wrong at Server Side"
    };
  }
};

export default api;
